import { baseApi, defaultQueryFreshness } from "./baseApi";

type OrderPayload = Record<string, unknown>;

export const ordersApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    createOrder: builder.mutation<unknown, OrderPayload>({
      query: (orderData) => ({ url: "/orders", method: "POST", data: orderData }),
      invalidatesTags: [{ type: "Orders", id: "LIST" }],
    }),
    getUserOrders: builder.query<unknown, string>({
      query: (userId) => ({ url: `/orders/user/${userId}`, method: "GET" }),
      providesTags: (_res, _err, userId) => [{ type: "Orders", id: `user:${userId}` }],
      ...defaultQueryFreshness,
    }),
    getSellerOrders: builder.query<unknown, string>({
      query: (userId) => ({ url: `/orders/seller/${userId}`, method: "GET" }),
      providesTags: (_res, _err, userId) => [{ type: "Orders", id: `seller:${userId}` }],
      ...defaultQueryFreshness,
    }),
    getOrderById: builder.query<unknown, string>({
      query: (orderId) => ({ url: `/orders/${orderId}`, method: "GET" }),
      providesTags: (_res, _err, orderId) => [{ type: "Orders", id: String(orderId) }],
      ...defaultQueryFreshness,
    }),
    updateOrderStatus: builder.mutation<unknown, { orderId: string; status: string; trackingNumber?: string | null }>({
      query: ({ orderId, status, trackingNumber = null }) => ({
        url: `/orders/${orderId}/status`,
        method: "PATCH",
        data: { status, trackingNumber },
      }),
      invalidatesTags: (_res, _err, { orderId }) => [{ type: "Orders", id: String(orderId) }, { type: "Orders", id: "LIST" }],
    }),
  }),
});

export const {
  useCreateOrderMutation,
  useGetUserOrdersQuery,
  useGetSellerOrdersQuery,
  useGetOrderByIdQuery,
  useUpdateOrderStatusMutation,
} = ordersApi;
